// Mock data for 360immoinvest clone - all data simulated, no backend yet.

export const NAV_LINKS = [
  { label: "Accueil", href: "/#accueil" },
  { label: "Tour", href: "/#tour" },
  { label: "Pourquoi nous ?", href: "/#pourquoi" },
  { label: "Tarifs", href: "/#tarifs" },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Créer un bien",
    desc: "Créez la fiche détaillée de votre bien immobilier (appartement, maison, parking, bureau, commerce...). Renseignez l'adresse, la surface, les équipements et toutes les informations utiles.",
    tags: ["Maison", "Appartement", "Parking"],
  },
  {
    step: "02",
    title: "Créer un locataire",
    desc: "Créez la fiche détaillée de votre locataire : nom, prénom, adresse, email, téléphone et toutes les informations utiles.",
    tags: ["Locataires", "Colocataires"],
  },
  {
    step: "03",
    title: "Créer une location",
    desc: "Liez votre bien immobilier et votre locataire dans un contrat de location. Précisez la durée du bail, le montant du loyer, des charges et toutes les conditions essentielles.",
    tags: ["Contrat de location"],
  },
];

export const FEATURES = [
  { icon: "ShieldCheck", title: "Compte sécurisé", desc: "Peu importe où vous êtes, 24/24, 7j/7, accédez facilement à votre portefeuille immobilier en ligne." },
  { icon: "FileText", title: "Modèle de bail pré-rempli", desc: "Créez votre location et obtenez un modèle de bail (vide, meublé, commercial) pré-rempli et conforme à la législation." },
  { icon: "CalendarDays", title: "Système de réservations", desc: "Des outils nécessaires à la gestion de vos calendriers et réservations pour les locations saisonnières." },
  { icon: "Calculator", title: "Régularisation des charges", desc: "Calcul de régularisation des charges locatives récupérables et génération du document à envoyer au locataire." },
  { icon: "Wallet", title: "Gestion des comptes", desc: "Gérez simplement vos dépenses et revenus fonciers et générez un bilan financier pour votre déclaration d'impôts." },
  { icon: "MessagesSquare", title: "Système de messagerie", desc: "Communication facile entre propriétaires et locataires via notre messagerie interne sécurisée." },
  { icon: "Landmark", title: "Synchronisation bancaire", desc: "Connectez vos comptes bancaires et récupérez vos transactions automatiquement dans le logiciel." },
  { icon: "Wrench", title: "Gestion des travaux", desc: "Module de suivi des travaux et interventions chez le locataire, de la demande à la facturation." },
  { icon: "Archive", title: "Archivage électronique", desc: "Archivez vos documents scannés (photos, factures, impôts, charges…) et partagez-les avec votre locataire." },
  { icon: "TrendingUp", title: "Révision de loyer", desc: "Révision annuelle du loyer selon l'indice de référence des loyers (IRL) et l'indice des loyers commerciaux (ILC)." },
  { icon: "Receipt", title: "Quittances électroniques", desc: "Fini le papier. Profitez dès maintenant de tous les avantages du service e-quittance." },
  { icon: "Sparkles", title: "Assistant IA", desc: "Notre IA génère vos documents, analyse vos finances et répond à vos questions de gestion locative." },
];

export const STATS = [
  { value: "83%", label: "de nos clients affirment que 360immoinvest les aide à mieux gérer." },
  { value: "97%", label: "de nos clients affirment gagner en efficacité et en productivité." },
  { value: "67%", label: "de nos clients recommandent 360immoinvest à leur entourage !" },
];

export const TESTIMONIALS = [
  { name: "Pierre", city: "Nîmes, France", text: "Ce site est un vrai bonheur pour les particuliers bailleurs et m'aide énormément ! À recommander !!", rating: 5 },
  { name: "Francine", city: "Paris, France", text: "Je tiens à vous dire un grand merci pour votre site, j'y ai appris énormément de choses. Bravo !", rating: 5 },
  { name: "Luc", city: "Lyon, France", text: "360immoinvest c'est génial, je fais de la pub à tout mon entourage. Merci à toute votre équipe !", rating: 5 },
];

export const PRICING = [
  {
    name: "Gratuit",
    price: "0€",
    period: "/ pour toujours",
    highlight: false,
    desc: "Idéal pour débuter la gestion d'un seul bien.",
    features: ["1 bien immobilier", "1 locataire", "Quittances de loyer", "Suivi des paiements", "Support par email"],
    cta: "Commencer gratuitement",
  },
  {
    name: "Premium",
    price: "9,90€",
    period: "/ mois",
    highlight: true,
    desc: "Pour les bailleurs qui gèrent plusieurs biens.",
    features: ["Biens illimités", "Locataires illimités", "Assistant IA complet", "Synchronisation bancaire", "Régularisation des charges", "Support prioritaire"],
    cta: "Essayer Premium",
  },
  {
    name: "Pro",
    price: "24,90€",
    period: "/ mois",
    highlight: false,
    desc: "Pour les professionnels et agences.",
    features: ["Tout Premium inclus", "Multi-utilisateurs", "Gestion mandats", "Rapports avancés", "API & intégrations", "Account manager dédié"],
    cta: "Contacter les ventes",
  },
];

// ---------------- Dashboard mock data ----------------

export const PROPERTIES = [
  { id: "b1", name: "Appartement Rivoli", type: "Appartement", address: "12 Rue de Rivoli, 75001 Paris", surface: 45, rooms: 2, rent: 1250, charges: 120, status: "Occupé", tenant: "Marie Durand", image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&q=80" },
  { id: "b2", name: "Studio Bastille", type: "Appartement", address: "3 Rue de la Paix, 75011 Paris", surface: 28, rooms: 1, rent: 890, charges: 80, status: "Occupé", tenant: "Thomas Petit", image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=600&q=80" },
  { id: "b3", name: "Maison Saint-Germain", type: "Maison", address: "45 Bd Saint-Germain, 75005 Paris", surface: 120, rooms: 5, rent: 2800, charges: 200, status: "Vacant", tenant: null, image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=600&q=80" },
  { id: "b4", name: "Loft Champs-Élysées", type: "Appartement", address: "78 Av Champs-Élysées, 75008 Paris", surface: 90, rooms: 3, rent: 2400, charges: 180, status: "Occupé", tenant: "Sophie Martin", image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&q=80" },
  { id: "b5", name: "Parking Vaugirard", type: "Parking", address: "210 Rue de Vaugirard, 75015 Paris", surface: 12, rooms: 0, rent: 150, charges: 0, status: "Vacant", tenant: null, image: "https://images.unsplash.com/photo-1590674899484-d5640e854abe?w=600&q=80" },
];

export const TENANTS = [
  { id: "t1", name: "Marie Durand", email: "marie.durand@email.fr", phone: "06 12 34 56 78", property: "Appartement Rivoli", since: "2023-01-15", status: "À jour", avatar: "MD" },
  { id: "t2", name: "Thomas Petit", email: "thomas.petit@email.fr", phone: "06 23 45 67 89", property: "Studio Bastille", since: "2022-09-01", status: "À jour", avatar: "TP" },
  { id: "t3", name: "Sophie Martin", email: "sophie.martin@email.fr", phone: "06 34 56 78 90", property: "Loft Champs-Élysées", since: "2024-03-10", status: "En retard", avatar: "SM" },
];

export const LEASES = [
  { id: "l1", property: "Appartement Rivoli", tenant: "Marie Durand", type: "Vide", start: "2023-01-15", end: "2026-01-14", rent: 1250, charges: 120, deposit: 1250, status: "Actif" },
  { id: "l2", property: "Studio Bastille", tenant: "Thomas Petit", type: "Meublé", start: "2022-09-01", end: "2025-08-31", rent: 890, charges: 80, deposit: 1780, status: "Actif" },
  { id: "l3", property: "Loft Champs-Élysées", tenant: "Sophie Martin", type: "Vide", start: "2024-03-10", end: "2027-03-09", rent: 2400, charges: 180, deposit: 2400, status: "Actif" },
];

export const RECEIPTS = [
  { id: "q1", tenant: "Marie Durand", property: "Appartement Rivoli", month: "Juillet 2025", amount: 1370, status: "Payé", date: "2025-07-03" },
  { id: "q2", tenant: "Thomas Petit", property: "Studio Bastille", month: "Juillet 2025", amount: 970, status: "Payé", date: "2025-07-02" },
  { id: "q3", tenant: "Sophie Martin", property: "Loft Champs-Élysées", month: "Juillet 2025", amount: 2580, status: "En attente", date: null },
  { id: "q4", tenant: "Marie Durand", property: "Appartement Rivoli", month: "Juin 2025", amount: 1370, status: "Payé", date: "2025-06-02" },
  { id: "q5", tenant: "Thomas Petit", property: "Studio Bastille", month: "Juin 2025", amount: 970, status: "Payé", date: "2025-06-01" },
];

export const TRANSACTIONS = [
  { id: "tr1", label: "Loyer - Marie Durand", type: "Revenu", amount: 1370, date: "2025-07-03", category: "Loyer" },
  { id: "tr2", label: "Loyer - Thomas Petit", type: "Revenu", amount: 970, date: "2025-07-02", category: "Loyer" },
  { id: "tr3", label: "Travaux plomberie - Loft", type: "Dépense", amount: 450, date: "2025-07-05", category: "Travaux" },
  { id: "tr4", label: "Taxe foncière", type: "Dépense", amount: 1200, date: "2025-06-28", category: "Impôts" },
  { id: "tr5", label: "Assurance PNO", type: "Dépense", amount: 320, date: "2025-06-15", category: "Assurance" },
  { id: "tr6", label: "Loyer - Sophie Martin", type: "Revenu", amount: 2580, date: "2025-06-03", category: "Loyer" },
];

export const REVENUE_CHART = [
  { month: "Fév", revenu: 4200, depense: 800 },
  { month: "Mar", revenu: 4800, depense: 1200 },
  { month: "Avr", revenu: 4800, depense: 600 },
  { month: "Mai", revenu: 5200, depense: 950 },
  { month: "Juin", revenu: 4920, depense: 1520 },
  { month: "Juil", revenu: 5340, depense: 450 },
];

export const CONVERSATIONS = [
  {
    id: "c1", name: "Marie Durand", property: "Appartement Rivoli", avatar: "MD", unread: 0,
    messages: [
      { from: "them", text: "Bonjour, la quittance de juillet est-elle disponible ?", time: "09:12" },
      { from: "me", text: "Bonjour Marie, oui je vous l'envoie dans la journée.", time: "09:30" },
      { from: "them", text: "Parfait, merci beaucoup !", time: "09:32" },
    ],
  },
  {
    id: "c2", name: "Sophie Martin", property: "Loft Champs-Élysées", avatar: "SM", unread: 2,
    messages: [
      { from: "them", text: "Bonjour, il y a une fuite sous l'évier de la cuisine.", time: "Hier" },
      { from: "them", text: "Pourriez-vous envoyer un plombier ?", time: "Hier" },
    ],
  },
  {
    id: "c3", name: "Thomas Petit", property: "Studio Bastille", avatar: "TP", unread: 0,
    messages: [
      { from: "me", text: "Bonjour Thomas, pensez à la révision annuelle du loyer.", time: "Lun" },
      { from: "them", text: "Bien noté, merci de l'information.", time: "Lun" },
    ],
  },
];

export const TASKS = [
  { id: "tk1", title: "Envoyer quittance Sophie Martin", due: "Aujourd'hui", done: false, priority: "haute" },
  { id: "tk2", title: "Planifier plombier - Loft Champs-Élysées", due: "Demain", done: false, priority: "haute" },
  { id: "tk3", title: "Révision loyer Studio Bastille", due: "12 juil.", done: false, priority: "moyenne" },
  { id: "tk4", title: "Déclarer taxe foncière", due: "15 juil.", done: true, priority: "basse" },
];

// AI assistant preset suggestions
export const AI_SUGGESTIONS = [
  "Rédige une lettre de relance de loyer impayé",
  "Calcule la révision de loyer selon l'IRL",
  "Résume ma situation financière du mois",
  "Génère un modèle de bail meublé",
];

// Mock AI replies keyed loosely (used by AssistantIA for demo)
export const AI_MOCK_REPLIES = [
  "Voici un modèle de lettre de relance :\n\nObjet : Relance pour loyer impayé\n\nMadame, Monsieur,\n\nSauf erreur de notre part, nous n'avons pas reçu le règlement du loyer du mois en cours d'un montant de [MONTANT] €. Nous vous invitons à régulariser votre situation sous 8 jours.\n\nCordialement,\n[VOTRE NOM]",
  "Pour la révision de loyer selon l'IRL : Nouveau loyer = Loyer actuel × (IRL du trimestre de référence / IRL de l'année précédente). Avec un IRL en hausse de ~3,5%, un loyer de 1 250 € passerait à environ 1 293,75 €.",
  "Situation financière du mois : Revenus 5 340 € • Dépenses 450 € • Résultat net +4 890 €. Vos loyers sont majoritairement à jour, seule la quittance de Sophie Martin est en attente.",
  "Voici un modèle de bail meublé conforme (loi ALUR) que vous pouvez personnaliser dans la section Locations. Il inclut : durée d'un an renouvelable, dépôt de garantie de 2 mois, inventaire du mobilier et clauses obligatoires.",
];
